// extracted by mini-css-extract-plugin
export default {"topbarCartBadge":"badge_topbarCartBadge__AGHad"};